import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useUsageEvents} from '../hooks/useUsageEvents';

export const ReloadRecordsButton = () => {

    // Same filter store, same cache key as the table, so Reload refetches what is shown.
    const {reload} = useUsageEvents();
    return (
        <Box mx='sm'>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};
